"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimulationPlot = exports.MatrixPlot = exports.ScatterPlot = exports.MultiBarChart = exports.MultiBarHorizontalChart = exports.PieChart = void 0;
var React = require("react");
var nv = require("nvd3");
var d3 = require("d3");
var utils_1 = require("../../utils");
var typestyle_1 = require("typestyle");
var App_1 = require("../../App");
var iterUtils_1 = require("../lib/iterUtils");
var config_1 = require("../../config");
var matrixUtils_1 = require("../admin/matrixUtils");
var PieChart = (function (_super) {
    __extends(PieChart, _super);
    function PieChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PieChart.prototype.componentWillReceiveProps = function (nextProps) {
        if (!this.chart)
            return;
        if (this.svg) {
            this.svg
                .datum(nextProps.data)
                .call(this.chart);
            this.update();
        }
    };
    PieChart.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return false;
    };
    PieChart.prototype.render = function () {
        var self = this;
        var baseClassName = "PieChart";
        return (React.createElement("form", { className: (0, typestyle_1.classes)(baseClassName, this.props.className) },
            React.createElement("svg", { ref: function (ref) {
                    nv.addGraph(function () {
                        self.chart = nv.models.pieChart()
                            .showLabels(true)
                            .labelType('value')
                            .x(function (d) { return d.label; })
                            .y(function (d) { return d.value; })
                            .valueFormat(d3.format(".0f"));
                        if (self.props.colors) {
                            self.chart.color(self.props.colors);
                        }
                        else {
                            self.chart.color(d3.scale.category20c().range());
                        }
                        self.svg = d3.select(ref);
                        self.svg
                            .datum(self.props.data)
                            .transition().duration(500)
                            .call(self.chart);
                        self.props.onElementClick && self.chart.pie.dispatch.on('elementClick', self.props.onElementClick);
                        self.update = function () {
                            if (!self.chart) {
                                console.log("Chart not ready for update yet");
                                return;
                            }
                            self.chart.update();
                        };
                        window.addEventListener("overview-tab-change", function () {
                            self.update();
                        });
                        return self.chart;
                    });
                } })));
    };
    return PieChart;
}(React.Component));
exports.PieChart = PieChart;
var MultiBarHorizontalChart = (function (_super) {
    __extends(MultiBarHorizontalChart, _super);
    function MultiBarHorizontalChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MultiBarHorizontalChart.prototype.componentWillReceiveProps = function (nextProps) {
        if (!this.chart)
            return;
        if (this.svg) {
            this.updateChart(nextProps);
        }
    };
    MultiBarHorizontalChart.prototype.updateChart = function (props) {
        var chartWidth = props.xAxisWide ? 600 : 500;
        var chartHeight = 100 + props.data[0].values.length * props.heightModifier;
        $(this.ref).parent().css('height', chartHeight);
        this.svg
            .datum(props.data)
            .transition().duration(200)
            .call(this.chart)
            .attr('width', chartWidth)
            .attr('height', chartHeight);
        this.chart
            .width(chartWidth)
            .height(chartHeight);
        this.chart.update && this.chart.update();
    };
    MultiBarHorizontalChart.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return false;
    };
    MultiBarHorizontalChart.prototype.render = function () {
        var self = this;
        return (React.createElement("form", { className: self.props.xAxisWide ? "MultiBarHorizontalChart--wide" : "MultiBarHorizontalChart" },
            React.createElement("svg", { ref: function (ref) {
                    self.ref = ref;
                    nv.addGraph(function () {
                        self.chart = nv.models.multiBarHorizontalChart()
                            .x(function (d) { return d.label; })
                            .y(function (d) { return d.value; })
                            .margin({ top: 50, right: 10, bottom: 20, left: self.props.xAxisWide ? 330 : 130 })
                            .showValues(true)
                            .stacked(false)
                            .showXAxis(self.props.showXAxis)
                            .showYAxis(self.props.showYAxis)
                            .valueFormat(d3.format("f"))
                            .showLegend(self.props.showLegend);
                        self.props.groupSpacing && self.chart.groupSpacing(0.2);
                        self.chart.tooltip.enabled(self.props.showTooltip);
                        if (self.props.colors) {
                            self.chart.color(self.props.colors);
                        }
                        self.svg = d3.select(ref);
                        self.updateChart(self.props);
                        self.props.onElementClick && self.chart.multibar.dispatch.on('elementClick', self.props.onElementClick);
                        $("g.nv-controlsWrap").remove();
                        return self.chart;
                    });
                } })));
    };
    return MultiBarHorizontalChart;
}(React.Component));
exports.MultiBarHorizontalChart = MultiBarHorizontalChart;
var MultiBarChart = (function (_super) {
    __extends(MultiBarChart, _super);
    function MultiBarChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MultiBarChart.prototype.get_tick_range = function (min, max, tickCount) {
        var range = max - min;
        var unroundedTickSize = range / (tickCount - 1);
        var x = Math.ceil((Math.log(unroundedTickSize) / Math.LN10) - 1);
        var pow10x = Math.pow(10, x);
        var roundedTickRange = Math.ceil(unroundedTickSize / pow10x) * pow10x;
        var tickRange = [];
        for (var i = min; i < tickCount; i++) {
            tickRange.push(i * roundedTickRange);
        }
        return tickRange;
    };
    MultiBarChart.prototype.render = function () {
        var self = this;
        var series = self.props.data;
        if (self.props.groupSize && self.props.groupSize > 1) {
            var new_series_1 = [];
            self.props.data.forEach(function (serie) {
                var new_values = [];
                serie.values.forEach(function (value, index) {
                    if (index > 0 && (index % self.props.groupSize) == 0) {
                        new_values.push({
                            label: new Array(index + 1).join(" "),
                            value: 0,
                        });
                    }
                    new_values.push(value);
                });
                new_series_1.push({
                    key: serie.key,
                    color: serie.color,
                    values: new_values
                });
            });
            series = new_series_1;
        }
        return (React.createElement("form", { className: "MultiBarChart" },
            React.createElement("svg", { ref: function (ref) {
                    var chart;
                    var chartHeight = 500;
                    var chartWidth = self.props.chartWidth || 800;
                    var format = self.props.format ? self.props.format : ",0f";
                    function wrap(parts, width) {
                        if (parts.length == 0)
                            return false;
                        parts.forEach(function (part1) {
                            part1.forEach(function (part2, index) {
                                var text = d3.select(part2);
                                var words = text.text().split(/\s+/).reverse();
                                var word = '';
                                var line = [];
                                var lineNumber = 0;
                                var lineHeight = 1;
                                var y = text.attr("y") || 0;
                                var dy = index + 1;
                                var tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em").style("text-anchor", "middle");
                                while (word = words.pop()) {
                                    line.push(word);
                                    tspan.text(line.join(" "));
                                    var node = tspan.node();
                                    var hasGreaterWidth = node.getComputedTextLength() > width;
                                    if (hasGreaterWidth) {
                                        line.pop();
                                        tspan.text(line.join(" "));
                                        line = [word];
                                        tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").style("text-anchor", "middle").text(word);
                                    }
                                }
                            });
                        });
                    }
                    nv.addGraph(function () {
                        chart = nv.models.multiBarChart()
                            .width(chartWidth)
                            .height(chartHeight)
                            .x(function (d) { return d.label; })
                            .y(function (d) { return d.value; })
                            .reduceXTicks(false)
                            .margin({ top: 100, bottom: 130, left: 100 })
                            .stacked(self.props.stacked)
                            .showLegend(self.props.showLegend)
                            .showControls(false)
                            .stackOffset('zero')
                            .rotateLabels(-40);
                        self.props.groupSpacing && chart.groupSpacing(0.5);
                        self.props.yAxisLabel &&
                            chart.yAxis
                                .axisLabel(self.props.yAxisLabel)
                                .axisLabelDistance(2);
                        chart.tooltip.enabled(true);
                        self.props.disableLegendUpdate &&
                            chart.legend.updateState(false);
                        self.props.xAxisLabel &&
                            chart.xAxis
                                .axisLabel(self.props.xAxisLabel)
                                .axisLabelDistance(-390);
                        chart.yAxis.tickFormat(d3.format(format));
                        d3.select(ref)
                            .datum(series)
                            .transition()
                            .duration(300)
                            .call(chart)
                            .attr('width', chartWidth)
                            .attr('height', chartHeight);
                        var domain = chart.yAxis.scale().domain();
                        var tickrange = $.map(self.get_tick_range(domain[0], domain[1], 10), function (n) { return Math.round(n); });
                        chart.yAxis
                            .tickValues(tickrange)
                            .tickFormat(d3.format(format));
                        self.props.onElementClick && chart.multibar.dispatch.on('elementClick', self.props.onElementClick);
                        nv.utils.windowResize(chart.update);
                        d3.select(".nvd3-svg .nv-x.nv-axis").selectAll(".tick").selectAll("text").call(wrap, 150);
                        d3.select(".nvd3-svg .nv-x.nv-axis").selectAll(".tick").selectAll("text").attr('transform', function () { return 'translate (-50, 40) rotate(-40 0,0)'; });
                        d3.select(".nvd3-svg .nv-x.nv-axis").selectAll(".nv-axislabel").attr('transform', function () { return 'translate (-100, 0)'; });
                        return chart;
                    });
                } })));
    };
    return MultiBarChart;
}(React.Component));
exports.MultiBarChart = MultiBarChart;
var ScatterPlot = (function (_super) {
    __extends(ScatterPlot, _super);
    function ScatterPlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ScatterPlot.prototype.componentWillReceiveProps = function (nextProps) {
        if (!this.chart)
            return;
        if (this.svg) {
            this.svg
                .datum(nextProps.data)
                .call(this.chart);
            this.update();
        }
    };
    ScatterPlot.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return false;
    };
    ScatterPlot.prototype.render = function () {
        var self = this;
        var maxX = self.props.maxX;
        var maxY = self.props.maxY;
        var processSvg = self.props.processSvg || (function (a, b) { return null; });
        return (React.createElement("div", { className: "ScatterPlot" },
            React.createElement("svg", { ref: function (ref) {
                    nv.addGraph(function () {
                        self.chart = nv.models.scatterChart()
                            .forceX([0, maxX])
                            .forceY([0, maxY])
                            .color(d3.scale.category20().range())
                            .duration(300);
                        self.props.chartSetup && self.props.chartSetup(self.chart);
                        self.chart.dispatch.on('renderEnd', function () {
                            processSvg(self.chart, self.svg);
                        });
                        self.props.onScatterClick && self.chart.scatter.dispatch.on('elementClick', self.props.onScatterClick);
                        self.svg = d3.select(ref);
                        self.svg
                            .datum(self.props.data)
                            .call(self.chart);
                        processSvg(self.chart, self.svg);
                        if (self.props.tooltipGenerator) {
                            self.chart.tooltip.contentGenerator(self.props.tooltipGenerator);
                        }
                        self.update = function () {
                            if (!self.chart) {
                                console.log("Chart not ready for update yet");
                                return;
                            }
                            self.props.chartSetup && self.props.chartSetup(self.chart);
                            self.chart.update();
                        };
                        window.addEventListener("overview-tab-change", function () {
                            self.update();
                        });
                        return self.chart;
                    });
                } })));
    };
    return ScatterPlot;
}(React.Component));
exports.ScatterPlot = ScatterPlot;
var MatrixPlot = (function (_super) {
    __extends(MatrixPlot, _super);
    function MatrixPlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MatrixPlot.prototype.render = function () {
        var _this = this;
        var self = this;
        var props = this.props;
        var matrix = props.matrix;
        var evaluations = matrix.evaluations
            .sort(function (a, b) { return b.var - a.var; })
            .sort(function (a, b) { return a.project_id - b.project_id; });
        if (self.props.numberToShow != "All") {
            evaluations = evaluations.slice(0, parseInt(self.props.numberToShow));
        }
        var ids = evaluations.map(function (e) { return e.risk_id; });
        var rows_by_evaluation = {};
        matrix.rows.forEach(function (row) {
            if ((0, iterUtils_1.contains)(ids, row.id)) {
                rows_by_evaluation[row.id] = row;
            }
        });
        var selectedDefinition = props.definitions[props.selected_definition];
        var is_opportunity = selectedDefinition.is_opportunity;
        var explicit_evaluation = selectedDefinition.explicit_evaluation && self.props.useQuantitative;
        var cells = self.getDecoratedCells(selectedDefinition);
        var colormap = is_opportunity ? {
            0: "#D9EFFF",
            10: "#ADDDFF",
            20: "#5CA3CA",
            30: "#006FAD",
        } : {
            0: "#3AA551",
            10: "#FCFE04",
            20: "#FC6604",
            30: "#C63418",
        };
        this.zones = cells.map(function (cell) {
            return {
                x1: cell.xOffsetBottom,
                x2: cell.xOffsetTop,
                y1: cell.yOffsetBottom,
                y2: cell.yOffsetTop,
                color: colormap[cell.color],
                cell: cell,
            };
        });
        this.data = [];
        (0, config_1.groupBy)(evaluations, function (e) { return e.project_title; })
            .forEach(function (group) {
            var values = [];
            var nonExplicitValuesByPoint = {};
            group.members.forEach(function (evaluation) {
                var row = rows_by_evaluation[evaluation.risk_id];
                var cell = _this.findCell(cells, evaluation, explicit_evaluation);
                cell.rows.push(row);
                if (explicit_evaluation) {
                    var cons = (evaluation.cons_mean > cell.consequence.high ?
                        cell.consequence.high : evaluation.cons_mean);
                    var freq = (evaluation.freq_mean > cell.frequency.high ?
                        cell.frequency.high : evaluation.freq_mean);
                    var xScale = (cons - cell.consequence.low) / (cell.consequence.high - cell.consequence.low);
                    var yScale = (freq - cell.frequency.low) / (cell.frequency.high - cell.frequency.low);
                    values.push({
                        x: cell.xOffsetBottom + (cell.xOffsetTop - cell.xOffsetBottom) * xScale,
                        y: cell.yOffsetBottom + (cell.yOffsetTop - cell.yOffsetBottom) * yScale,
                        label: "#".concat(evaluation.risk_number),
                        rows: [row],
                    });
                }
                else {
                    var point = {
                        x: cell.xOffsetBottom + (cell.xOffsetTop - cell.xOffsetBottom) / 2,
                        y: cell.yOffsetBottom + (cell.yOffsetTop - cell.yOffsetBottom) / 2,
                    };
                    var key = "".concat(point.x, "-").concat(point.y);
                    if (!nonExplicitValuesByPoint[key]) {
                        nonExplicitValuesByPoint[key] = {
                            x: point.x,
                            y: point.y,
                            label: "",
                            rows: [],
                        };
                        values.push(nonExplicitValuesByPoint[key]);
                    }
                    nonExplicitValuesByPoint[key].rows.push(row);
                    nonExplicitValuesByPoint[key].label = "".concat(nonExplicitValuesByPoint[key].rows.length);
                }
            });
            _this.data.push({
                key: group.key,
                values: values,
            });
        });
        function chartSetup(chart) {
            var selectedDefinition = props.definitions[props.selected_definition];
            self.chartSetup(chart, selectedDefinition);
        }
        return (React.createElement("div", { className: "MatrixPlot" },
            React.createElement(ScatterPlot, { data: this.data, processSvg: this.processSvg.bind(this), chartSetup: chartSetup, onScatterClick: this.onScatterClick.bind(this), maxX: 100.0, maxY: 100.0 })));
    };
    MatrixPlot.prototype.getDecoratedCells = function (matrix) {
        var width = 100.0;
        var height = 100.0;
        var result = [];
        var columns = matrix.consequences.length;
        var rows = matrix.frequencies.length;
        matrix.frequencies.forEach(function (frequency) {
            matrix.consequences.forEach(function (consequence) {
                var xOffsetFactor = 1 / columns * width;
                var xOffsetBottom = xOffsetFactor * (consequence.column - 1);
                var xOffsetTop = xOffsetFactor * consequence.column;
                var yOffsetFactor = 1 / rows * height;
                var yOffsetBottom = yOffsetFactor * (frequency.row - 1);
                var yOffsetTop = yOffsetFactor * frequency.row;
                var cell = matrix.cells.filter(function (cell) { return (cell.row === frequency.row &&
                    cell.column === consequence.column); })[0];
                result.push({
                    xOffsetBottom: xOffsetBottom,
                    xOffsetTop: xOffsetTop,
                    yOffsetBottom: yOffsetBottom,
                    yOffsetTop: yOffsetTop,
                    consequence: consequence,
                    frequency: frequency,
                    color: cell.color,
                    id: cell.id,
                    rows: [],
                });
            });
        });
        return result;
    };
    MatrixPlot.prototype.onMatrixChange = function (event) {
        var target = event.target;
        var value = target.value;
        this.setState({
            selectedDefinition: value
        });
    };
    MatrixPlot.prototype.findCell = function (cells, evaluation, explicit_values) {
        var e_1, _a;
        var maxFrequency = cells
            .sort(function (a, b) { return b.frequency.high - a.frequency.high; })[0].frequency.high;
        var maxConsequence = cells
            .sort(function (a, b) { return b.consequence.high - a.consequence.high; })[0].consequence.high;
        var minFrequency = cells
            .sort(function (b, a) { return b.frequency.high - a.frequency.high; })[0].frequency.high;
        var minConsequence = cells
            .sort(function (b, a) { return b.consequence.high - a.consequence.high; })[0].consequence.high;
        try {
            for (var cells_1 = __values(cells), cells_1_1 = cells_1.next(); !cells_1_1.done; cells_1_1 = cells_1.next()) {
                var cell = cells_1_1.value;
                if (explicit_values) {
                    var freq_match = (cell.frequency.low < evaluation.freq_mean &&
                        evaluation.freq_mean <= cell.frequency.high) || cell.frequency.low === 0 && evaluation.freq_mean === 0;
                    var cons_match = (cell.consequence.low < evaluation.cons_mean &&
                        evaluation.cons_mean <= cell.consequence.high) || cell.consequence.low === 0 && evaluation.cons_mean === 0;
                    var match_out_of_bounds_high_cons = (evaluation.cons_mean > maxConsequence && cell.consequence.high == maxConsequence);
                    var match_out_of_bounds_high_freq = (evaluation.freq_mean > maxFrequency && cell.frequency.high == maxFrequency);
                    var match_out_of_bounds_low_cons = (evaluation.cons_mean < minConsequence && cell.consequence.low == minConsequence);
                    var match_out_of_bounds_low_freq = (evaluation.freq_mean < minFrequency && cell.frequency.low == minFrequency);
                    var fullMatch = freq_match && cons_match;
                    var freqMatchConsBounds = ((freq_match && match_out_of_bounds_low_cons) ||
                        (freq_match && match_out_of_bounds_high_cons));
                    var consMatchFreqBounds = ((cons_match && match_out_of_bounds_low_freq) ||
                        (cons_match && match_out_of_bounds_high_freq));
                    var allLowBound = match_out_of_bounds_low_cons && match_out_of_bounds_low_freq;
                    var allHighBound = match_out_of_bounds_high_cons && match_out_of_bounds_high_freq;
                    if (fullMatch || freqMatchConsBounds || consMatchFreqBounds || allLowBound || allHighBound) {
                        return cell;
                    }
                }
                else {
                    if (cell.frequency.row === evaluation.cell_row && cell.consequence.column === evaluation.cell_column) {
                        return cell;
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (cells_1_1 && !cells_1_1.done && (_a = cells_1.return)) _a.call(cells_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        throw new Error("Cannot determine cell");
    };
    MatrixPlot.prototype.processSvg = function (chart, svg) {
        var self = this;
        var selectedDefinition = self.props.definitions[self.props.selected_definition];
        var explicit_evaluation = selectedDefinition.explicit_evaluation && self.props.useQuantitative;
        svg.selectAll(".scatterlabel").remove();
        var placer = new utils_1.Placer({
            minX: chart.xAxis.scale()(2),
            maxX: chart.xAxis.scale()(90),
            minY: chart.yAxis.scale()(92),
            maxY: chart.yAxis.scale()(2),
        });
        this.data.forEach(function (d) {
            if (d.disabled) {
                return;
            }
            d.values.forEach(function (data) {
                if (explicit_evaluation) {
                    var x = chart.xAxis.scale()(data.x), y = chart.yAxis.scale()(data.y);
                    var labelCoordinate = placer.getPlacement({ x: x, y: y });
                    svg.select("g.nv-group").append("text")
                        .attr("x", labelCoordinate.x)
                        .attr("y", labelCoordinate.y)
                        .attr("stroke", d.color)
                        .attr("class", "scatterlabel")
                        .text(data.label);
                }
                else {
                    var x = chart.xAxis.scale()(data.x) - 3, y = chart.yAxis.scale()(data.y) + 2;
                    svg.select("g.nv-group").append("text")
                        .attr("x", x)
                        .attr("y", y)
                        .attr("stroke", "black")
                        .attr("class", "cellLabel")
                        .text(data.label);
                }
            });
        });
        svg.selectAll(".scatterlabel").forEach(function (texts) {
            texts.forEach(function (t) {
                var textBBox;
                try {
                    textBBox = t.getBBox();
                }
                catch (e) {
                    textBBox = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0,
                    };
                }
                svg.select("g.nv-group").insert("rect", ":first-child")
                    .attr("x", textBBox.x - 2)
                    .attr("y", textBBox.y - 2)
                    .attr("rx", 4)
                    .attr("ry", 4)
                    .attr("width", textBBox.width + 4)
                    .attr("height", textBBox.height + 4)
                    .attr("fill", "black")
                    .attr("stroke", "black")
                    .attr("fill-opacity", "1")
                    .attr("stroke-opacity", "1");
            });
        });
        if (!explicit_evaluation) {
            svg.selectAll(".nv-point").remove();
        }
        function insertLinebreaks(d) {
            var self = this;
            var el = $(d3.select(this).node());
            var sections = el.text().split("\n");
            el.text('');
            d3.select(self).append("tspan").text(sections[0]);
            d3.select(self)
                .append("tspan")
                .attr('x', "0")
                .attr('dx', "0")
                .attr('dy', "10")
                .text(sections[1]);
        }
        svg.selectAll('g.nv-axis g text').each(insertLinebreaks);
        var xTicks = svg.select('.nv-x.nv-axis').selectAll('g');
        xTicks
            .selectAll('text')
            .attr('transform', function () { return 'translate (-20, 140) rotate(-90 0,0)'; });
        function wrap(parts, width) {
            if (parts.length == 0)
                return false;
            parts.forEach(function (part1) {
                part1.forEach(function (part2, index) {
                    var text = d3.select(part2);
                    var words = text.text().split(/\s+/).reverse();
                    var word = '';
                    var line = [];
                    var lineNumber = 0;
                    var lineHeight = 1;
                    var y = text.attr("y") || 0;
                    var dy = index + 1;
                    var tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em").style("text-anchor", "start");
                    while (word = words.pop()) {
                        line.push(word);
                        tspan.text(line.join(" "));
                        var node = tspan.node();
                        var hasGreaterWidth = node.getComputedTextLength() > width;
                        if (hasGreaterWidth) {
                            line.pop();
                            tspan.text(line.join(" "));
                            line = [word];
                            tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").style("text-anchor", "start").text(word);
                        }
                    }
                });
            });
        }
        svg.select(".nv-x.nv-axis").selectAll(".tick").selectAll("text").selectAll("tspan").call(wrap, 150);
        svg.select(".colorZone").remove();
        var zones = this.zones;
        var _loop_1 = function (i) {
            var obj = zones[i];
            var x = chart.xAxis.scale()(obj.x1), y = chart.yAxis.scale()(obj.y1);
            var width = chart.xAxis.scale()(obj.x2) - x, height = y - chart.yAxis.scale()(obj.y2);
            y = y - height;
            svg.select("g.nv-group").insert("rect", ":first-child")
                .attr("x", x)
                .attr("y", y)
                .attr("width", width)
                .attr("height", height)
                .attr("fill", obj.color)
                .attr("stroke", "black")
                .attr("class", "colorZone")
                .on("click", function () { return self.onZoneClick(obj.cell); });
        };
        for (var i = 0; i < zones.length; i++) {
            _loop_1(i);
        }
    };
    MatrixPlot.prototype.chartSetup = function (chart, matrixDefinition) {
        var rows = matrixDefinition.frequencies.length;
        var columns = matrixDefinition.consequences.length;
        var rowTicks = [];
        var rowTickFormats = {};
        matrixDefinition.frequencies
            .sort(function (a, b) { return a.row - b.row; })
            .forEach(function (freq, i) {
            var value = i * 100 / rows + 100 / rows / 2;
            rowTicks.push(value);
            rowTickFormats[value] = freq.name + "\n" + (0, matrixUtils_1.displayFrequency)(freq, matrixDefinition.frequency_display);
        });
        chart.yAxis.tickValues(rowTicks);
        chart.yAxis.tickFormat(function (d) {
            return rowTickFormats[d];
        });
        chart.margin({ top: 0, right: 0, bottom: 150, left: 130 });
        chart.tooltip.enabled(false);
        chart.width(500);
        chart.height(400);
        var columnTicks = [];
        var columnTickFormats = {};
        matrixDefinition.consequences
            .sort(function (a, b) { return a.column - b.column; })
            .forEach(function (cons, i) {
            var value = i * 100 / columns + 100 / columns / 2;
            columnTicks.push(value);
            columnTickFormats[value] = cons.name + "\n" + (0, matrixUtils_1.displayConsequence)(cons, matrixDefinition.consequence_display);
        });
        chart.xAxis.tickValues(columnTicks);
        chart.xAxis.tickFormat(function (d) {
            return columnTickFormats[d];
        });
    };
    MatrixPlot.prototype.onScatterClick = function (obj) {
        App_1.store.editableListDialog.openDialog(gettext("Risks"), {
            rows: obj.point.rows,
            columns: this.props.matrix.columns,
            headers: this.props.matrix.headers,
        });
    };
    MatrixPlot.prototype.onZoneClick = function (cell) {
        App_1.store.editableListDialog.openDialog(gettext("Risks"), {
            rows: cell.rows,
            columns: this.props.matrix.columns,
            headers: this.props.matrix.headers,
        });
    };
    return MatrixPlot;
}(React.Component));
exports.MatrixPlot = MatrixPlot;
var SimulationPlot = function (props) {
    var width = props.width || 1000;
    var height = props.height || 500;
    var style = width && height && {
        width: width,
        height: height,
    };
    var className = (0, typestyle_1.classes)("SimulationPlot", props.showY2Axis ? "" : "SimulationPlot--hideY2");
    return (React.createElement("div", { className: className, style: style },
        React.createElement("svg", { ref: function (ref) {
                nv.addGraph(function () {
                    var chart = nv.models.linePlusBarChart()
                        .showLegend(false)
                        .focusEnable(false)
                        .height(height)
                        .width(width)
                        .margin({ top: 30, right: 60, bottom: 50, left: 70 })
                        .x(function (d) { return d.label; })
                        .y(function (d) { return d.value; });
                    chart.xAxis
                        .axisLabel(props.xLabel)
                        .tickFormat(d3.format(".02f"));
                    chart.y1Axis.tickFormat(d3.format(".0f"));
                    chart.y2Axis.tickFormat(d3.format(".0f"));
                    chart.bars.yDomain([0, 100]);
                    chart.lines.yDomain([0, 100]);
                    chart.lines.interpolate("linear");
                    d3.select(ref)
                        .datum([props.bars, props.curve])
                        .attr('width', width)
                        .attr('height', height)
                        .transition()
                        .duration(0)
                        .call(chart);
                    nv.utils.windowResize(chart.update);
                    props.processSvg && props.processSvg(d3.select(ref), chart);
                    return chart;
                });
            } })));
};
exports.SimulationPlot = SimulationPlot;
